import { formatSiteMoney } from "@shared/currency";

export type ListingCarCardData = {
  id: number;
  titleAr: string;
  mainImage: string;
  galleryPreview?: string[];
  year: number;
  mileage: number;
  fuelType: string;
  /** Arabic: يدوي / أوتوماتيك · from `cars.transmission` when list payload includes it */
  transmission?: string | null;
  location: string;
  createdAt: Date | string;
  /** When schema adds publish workflow */
  publishedAt?: Date | string | null;
  dealershipName?: string | null;
  /** From listing seller (`users.name`) when not a named dealership */
  sellerName?: string | null;
  sellerId?: number;
  sellerDisplayName?: string | null;
  sellerType?: "dealership" | "private" | string | null;
  saleType: "auction" | "fixed";
  auctionCondition?: string | null;
  fixedPrice?: {
    finalPrice: string;
    price: string;
  };
  auction?: {
    currentBid: string;
    startingPrice: string;
  };
  /** True when listing has an active paid boost */
  isBoosted?: boolean;
  /** True when the listing is marked تصلح للاعفاء الجمركي. */
  customsExempt?: boolean;
};

export function formatListingCardPrice(car: ListingCarCardData): string | null {
  if (car.saleType === "auction") {
    const bid = car.auction?.currentBid;
    if (bid != null && String(bid).trim() !== "") return formatSiteMoney(bid);
    const start = car.auction?.startingPrice;
    if (start != null && String(start).trim() !== "") return formatSiteMoney(start);
    return null;
  }
  const fp = car.fixedPrice;
  const amt = fp?.finalPrice ?? fp?.price;
  if (amt != null && String(amt).trim() !== "") return formatSiteMoney(amt);
  return null;
}
